// Client portal: funds waiting in the client's own Stripe account (their share
// of split invoice payments) and the Request cashout flow. The business
// approves or holds each request; approved cashouts go to the client's bank.
import React, { useCallback, useEffect, useState } from 'react';
import portalAPI from './portalApi';
import { formatApiError } from '../../utils/errorMessage';

const STATUS = { requested: 'Waiting for approval', held: 'On hold', approved: 'Approved, on its way', paid: 'Paid to your bank', failed: 'Failed', canceled: 'Canceled' };

export default function PortalCashout() {
  const [state, setState] = useState(null);
  const [amount, setAmount] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const load = useCallback(async () => {
    try { setState((await portalAPI.cashout()).data); } catch (e) { setState(null); }
  }, []);
  useEffect(() => { load(); }, [load]);
  if (!state || !state.available) return null;
  const open = (state.requests || []).some((r) => ['requested', 'held', 'approved'].includes(r.status));
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError('');
    try { await portalAPI.requestCashout(amount ? { amount } : {}); setAmount(''); await load(); } catch (err) { setError(formatApiError(err, 'Could not request the cashout')); }
    setBusy(false);
  };
  return (
    <section aria-label="Client balance" className="border rounded p-3 text-sm space-y-2">
      <h2 className="font-semibold">Your balance</h2>
      <p>Available: ${state.balance.available}{state.balance.pending !== '0.00' ? ` (on the way: $${state.balance.pending})` : ''}</p>
      {!open && state.balance.available !== '0.00' && (
        <form onSubmit={submit} className="flex gap-2 items-center">
          <input aria-label="Cashout amount" className="border rounded px-2 py-1 w-28" inputMode="decimal" placeholder={state.balance.available}
            value={amount} onChange={(e) => setAmount(e.target.value)} />
          <button type="submit" disabled={busy} className="border rounded px-3 py-1">Request cashout</button>
        </form>
      )}
      {(state.requests || []).length > 0 && (
        <ul className="text-xs">
          {state.requests.map((r) => <li key={r.id}>${r.amount}: {STATUS[r.status] || r.status}</li>)}
        </ul>
      )}
      {error && <p role="alert" className="text-red-600 text-xs">{error}</p>}
    </section>
  );
}
